<script>
  import Menu from "./Menu.svelte";
  import Section01 from "./section01.svelte";
  import Section02 from "./section02.svelte";
  import About from "./About.svelte";
  import SpineSection from "./SpineSection.svelte";
  import CaseStudy from "./CaseStudy.svelte";
  import Profile from "./Profile.svelte";
  import GridText from "./GridText.svelte";   
  import NewLanding from "./NewLanding.svelte"; 
  import Overlay from "./Overlay.svelte";
</script>

<link rel="preconnect" href="https://fonts.googleapis.com" />
<svelte:head>
  
  <script src="https://code.jquery.com/pep/0.4.3/pep.js"></script>
</svelte:head>

<link rel="preconnect" href="https://fonts.gstatic.com" crossorigin />
<link
  href="https://fonts.googleapis.com/css2?family=Barlow:wght@100;500;600;900&display=swap"
  rel="stylesheet"
/>
<main>
  <div class="overlay">
<Overlay />
  </div>
  <Menu /> 
  <NewLanding /> 
  <About />
  <CaseStudy />
  <SpineSection />
  <Profile />
  <Section02 />
  <GridText />
 
</main>

<style>
  .overlay{
    position: fixed;
    width: 100%;
    margin: auto;
    height: 100vh;
    display: flex;
    align-items: center;
    left: 0px;
    display: none;
    padding: 24px;
    right: 0px; 
    bottom: 0px;
    z-index: 1000;
    background-color: rgb(0 0 0 / 90%);
  }

</style>
